import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import Chart from 'react-google-charts';
import axios from 'axios';

export default function VisitationAnnualAdRentReport() {

    const VISITATION_BASE_URL = process.env.REACT_APP_VISITATION_BASE_URL;
    const VISITATION_GETALL = process.env.REACT_APP_VISITATION_SEARCH;

    const [visitationData, setVisitationData] = useState([]);
    const visitData = {
        siteName: "",
        year: "",
        month: "",
        status: "APPROVED"
    }

    // All Visitation records 
    useEffect(() => {
        const visitationAPI = VISITATION_BASE_URL + VISITATION_GETALL;
        console.log('visitation api ' + visitationAPI)
        if (visitationAPI) {
            const fetchdata = async () => {
                try {
                    const response = await axios.post(visitationAPI, visitData)
                    setVisitationData(response.data);
                } catch (error) {
                    console.error(error)
                }
            };
            fetchdata();
        }
    }, []);

    const getTotalPaid = (visitationData) => {
        const totalYearValues = {};
        const siteFiscalData = {};

        visitationData.forEach(entry => {
            const { siteName, fiscalYear, visitation } = entry;
            const totalPaid = visitation.paid.totalPaid || 0;

            if (!siteFiscalData[siteName]) {
                siteFiscalData[siteName] = {};
            }
            if (!siteFiscalData[siteName][fiscalYear]) {
                siteFiscalData[siteName][fiscalYear] = 0;
            }
            siteFiscalData[siteName][fiscalYear] += totalPaid;

            totalYearValues[fiscalYear] = (totalYearValues[fiscalYear] || 0) + totalPaid;
        });


        const sortedYears = Array.from(new Set(visitationData.map(entry => entry.fiscalYear))).sort();
        const resultArray = [['SiteName', `FY${sortedYears}`, '% Change']]; // Get unique years

        Object.entries(siteFiscalData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(fiscalYear => (yearsData[fiscalYear] || 0)),
                calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        console.log('arry: ' + resultArray);
        return resultArray;
    }





    const getTotalUnpaid = (visitationData) => {
        const totalYearValues = {};
        const siteFiscalData = {};

        visitationData.forEach(entry => {
            const { siteName, fiscalYear, visitation } = entry;
            const totalUnpaid = visitation.unpaid.totalUnpaid || 0;

            if (!siteFiscalData[siteName]) {
                siteFiscalData[siteName] = {};
            }
            if (!siteFiscalData[siteName][fiscalYear]) {
                siteFiscalData[siteName][fiscalYear] = 0;
            }
            siteFiscalData[siteName][fiscalYear] += totalUnpaid;
            totalYearValues[fiscalYear] = (totalYearValues[fiscalYear] || 0) + totalUnpaid;
        });

        const sortedYears = Array.from(new Set(visitationData.map(entry => entry.fiscalYear))).sort();
        const resultArray = [['SiteName', `FY${sortedYears}`, '% Change']]; // Get unique years

        Object.entries(siteFiscalData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(fiscalYear => (yearsData[fiscalYear] || 0)), calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }

    const calculatePercentageChange = (yearsData) => {
        const values = Object.values(yearsData);
        const len = values.length;
        if (len >= 2) {
            const percentageChange = ((values[len - 1] - values[len - 2]) / Math.abs(values[len - 2])) * 100;
            return parseFloat(isNaN(percentageChange) ? 0 : percentageChange.toFixed(2));
        }
        return 0;
    };

    const getAdmissionRevenue = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};


        visitationData.forEach(entry => {
            const { siteName, fiscalYear, revenue } = entry;
            const total = parseFloat(revenue.totalAdmissionsRevenue) || 0.00;
            const phmcShare = parseFloat(revenue.phmcAdmissionShare) || 0.00;
            const associateShare = parseFloat(revenue.associateAdmissionShare) || 0.00;
            if (!resultData[siteName]) {
                resultData[siteName] = {};
                console.log(`${siteName}: ${Object.values(resultData[siteName])} `);
            }
            if (!resultData[siteName][fiscalYear]) {
                resultData[siteName][fiscalYear] = { total: 0, phmcShare: 0, associateShare: 0 };
                console.log(resultData[siteName][fiscalYear]);
            }
            resultData[siteName][fiscalYear] = {
                total: resultData[siteName][fiscalYear].total + total,
                phmcShare: resultData[siteName][fiscalYear].phmcShare + phmcShare,
                associateShare: resultData[siteName][fiscalYear].associateShare + associateShare
            }
            totalYearValues[fiscalYear] = {
                total: (totalYearValues[fiscalYear] ? totalYearValues[fiscalYear].total || 0 : 0) + total,
                phmcShare: (totalYearValues[fiscalYear] ? totalYearValues[fiscalYear].phmcShare || 0 : 0) + phmcShare,
                associateShare: (totalYearValues[fiscalYear] ? totalYearValues[fiscalYear].associateShare || 0 : 0) + associateShare
            };

        });

        const sortedYears = Array.from(new Set(visitationData.map(entry => entry.fiscalYear))).sort();
        const ar = sortedYears.flatMap(fiscalYear => [`${fiscalYear} _total`, `${fiscalYear} _phmc`, `${fiscalYear} _associate`]);

        console.log(ar);
        const resultArray = [['SiteName',
            ...sortedYears.flatMap(fiscalYear => [`FY${fiscalYear} Total Admissions`, `FY${fiscalYear} PHMC Share`, `FY${fiscalYear} Associate Share`])

        ]
        ]; // Get unique years
        Object.entries(resultData).forEach((sitename, yearsdata) => {
            Object.values(yearsdata).forEach(e => console.log(e))
        })
        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName,
                ...Object.values(yearsData).flatMap(entry => [entry.total, entry.phmcShare, entry.associateShare]),
            ];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total',
            ...sortedYears.flatMap(fiscalYear => totalYearValues[fiscalYear] ? [totalYearValues[fiscalYear].total || 0, totalYearValues[fiscalYear].phmcShare, totalYearValues[fiscalYear].associateShare] : 0)
        ];
        resultArray.push(totalRow);
        return resultArray;
    }


    const getEventTotalPaid = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};


        visitationData.forEach(entry => {
            const { siteName, fiscalYear, eventsAdmissions } = entry;
            const totalValue = parseFloat(eventsAdmissions.visitorsPaid || 0);
            if (!resultData[siteName]) {
                resultData[siteName] = {};
            } if (!resultData[siteName][fiscalYear]) {
                resultData[siteName][fiscalYear] = 0;
            }
            resultData[siteName][fiscalYear] += totalValue;
            totalYearValues[fiscalYear] = (totalYearValues[fiscalYear] || 0) + totalValue;
        });

        const sortedYears = Array.from(new Set(visitationData.map(entry => entry.fiscalYear))).sort();
        const resultArray = [['SiteName', `FY ${sortedYears}`, '% Change']]; // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(fiscalYear => (yearsData[fiscalYear] || 0)),
                calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }

    const getEventTotalUnpaid = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};



        visitationData.forEach(entry => {
            const { siteName, fiscalYear, eventsAdmissions } = entry;
            const totalValue = parseFloat(eventsAdmissions.visitorsUnPaid || 0);
            if (!resultData[siteName]) {
                resultData[siteName] = {};
            } if (!resultData[siteName][fiscalYear]) {
                resultData[siteName][fiscalYear] = 0;
            }
            resultData[siteName][fiscalYear] += totalValue;
            totalYearValues[fiscalYear] = (totalYearValues[fiscalYear] || 0) + totalValue;
        });

        const sortedYears = Array.from(new Set(visitationData.map(entry => entry.fiscalYear))).sort();
        const resultArray = [['SiteName', `FY ${sortedYears}`, '% Change']]; // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(fiscalYear => (yearsData[fiscalYear] || 0)),
                calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }

    const getEventRevenue = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};


        visitationData.forEach(entry => {
            const { siteName, fiscalYear, eventsAdmissions } = entry;
            const totalValue = parseFloat(eventsAdmissions.totalEventRevenue) || 0;
            if (!resultData[siteName]) {
                resultData[siteName] = {};
            } if (!resultData[siteName][fiscalYear]) {
                resultData[siteName][fiscalYear] = 0;
            }
            resultData[siteName][fiscalYear] += totalValue;
            totalYearValues[fiscalYear] = (totalYearValues[fiscalYear] || 0) + totalValue;
        });

        const sortedYears = Array.from(new Set(visitationData.map(entry => entry.fiscalYear))).sort();
        const resultArray = [['SiteName', `FY ${sortedYears}`, '% Change']]; // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(fiscalYear => (yearsData[fiscalYear] || 0)),
                calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }

    const paidVisitData = getTotalPaid(visitationData);
    console.log('Paid:' + paidVisitData);
    const paidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const paidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: paidVisitData[0].length - 1,
        },
    ];

    const unpaidVisitData = getTotalUnpaid(visitationData);
    console.log('Unpaid:' + unpaidVisitData)
    const unpaidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const unpaidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: unpaidVisitData[0].length - 1,
        },
    ];

    const admissionRevenue = getAdmissionRevenue(visitationData);
    console.log('revenue:' + admissionRevenue);
    const admissionRevenueOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const admissionRevenueFormatters = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                prefix: "$"
            }
        },
        {
            type: "NumberFormat",
            column: 2,
            options: {
                prefix: "$"
            }
        },
        {
            type: "NumberFormat",
            column: 3,
            options: {
                prefix: "$"
            }
        },
    ];

    const eventPaidVisitData = getEventTotalPaid(visitationData);
    console.log(eventPaidVisitData);
    const eventPaidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const eventPaidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: eventPaidVisitData[0].length - 1,
        },
    ];

    const eventUnpaidVisitData = getEventTotalUnpaid(visitationData);
    console.log(eventUnpaidVisitData)
    const eventUnpaidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const eventUnpaidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: eventUnpaidVisitData[0].length - 1,
        },
    ];

    const eventRevenueData = getEventRevenue(visitationData);
    console.log(eventRevenueData)
    const eventRevenueDataOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const eventRevenueDataFormatters = [
        {
            type: "ArrowFormat",
            column: eventRevenueData[0].length - 1,
        },
    ];

    const downloadCSV = () => {

        const combinedData = [
            ['Admissions Revenue'],
            ...admissionRevenue.map(row => row.join(',')),
            [''],
            ['Event Attendance Revenue'],
            ...eventRevenueData.map(row => row.join(',')),
            [''],
        ];

        // Convert the chart data to CSV format
        const csvContent = combinedData.join('\n');
        // Create a data URI for the CSV content
        const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent);
        // Create a download link
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'VisitionaAnnualAdAndRentReport.csv');
        // Append the link to the document body and trigger the click event
        document.body.appendChild(link);
        link.click();
    };
    const createDownloadHandler = () => {
        return () => downloadCSV();
    };
    return (
        <>
            <span ><b>Visitation Annual Ad & Rent Revenue </b> </span>

            {visitationData.length > 0 &&
                <Row className="mb-0 main-content" >
                    <Col>
                        <Button onClick={createDownloadHandler()}>Download Data</Button>
                    </Col>
                    <Col />
                    <Col />
                    <Col />
                </Row>
            }
            <Row className="mb-0 main-content" >
                <Col>
                    <Card>
                        <Card.Title>Admissions Revenue</Card.Title>
                        <Card.Body>

                            <Chart
                                width={'100%'}
                                height={'100%'}
                                chartType="Table"
                                loader={<div>Loading Chart</div>}
                                data={admissionRevenue}
                                options={admissionRevenueOptions}
                                formatters={admissionRevenueFormatters}
                            />
                        </Card.Body>


                    </Card>
                </Col>

            </Row>

            <Row className="mb-0 main-content" >
                <Col>
                    <Card>
                        <Card.Title> Event Attendance Revenue</Card.Title>
                        <Card.Body>

                            <Chart
                                width={'100%'}
                                height={'100%'}
                                chartType="Table"
                                loader={<div>Loading Chart</div>}
                                data={eventRevenueData}
                                options={eventRevenueDataOptions}
                                formatters={eventRevenueDataFormatters}
                            />
                        </Card.Body>


                    </Card>
                </Col>


            </Row>
        </>
    );
}